import styled from 'styled-components';
import { Layout } from 'components/atoms/layout';
import {
  BodyShort01,
  ProductiveHeading04,
  ProductiveHeading05,
  ProductiveHeading03,
} from 'components/styles';

const { Content } = Layout;

export const Container = styled(Content)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 120px;
  align-items: flex-start;
`;
export const Title = styled.h2`
  ${ProductiveHeading03};
  margin-top: var(--spacing-04);
  margin-bottom: var(--spacing-03);
`;
export const Heading = styled.div`
  ${ProductiveHeading04};
  margin-top: var(--spacing-08);
  margin-bottom: var(--spacing-03);
`;
export const Description = styled.p`
  ${ProductiveHeading05};
  font-weight: var(--heading-2-weight);
`;

export const Help = styled.div`
  color: var(--coolest-gray-70);
  margin-top: var(--spacing-03);
  margin-bottom: var(--spacing-06);
  font-size: var(--font-size-sm);
`;

export const RowHelp = styled(Help)`
  margin-top: calc(-1 * var(--spacing-03));
`;

export const UserInfo = styled.div`
  ${BodyShort01};
  color: var(--coolest-gray-70);
  margin: var(--spacing-05) 0 var(--spacing-07) 0;
`;

export const LinkText = styled.span`
  ${BodyShort01};
  margin-bottom: 0;
`;

export const ErrorMessage = styled.p`
  color: var(--red-60);
`;
